// extracted by mini-css-extract-plugin
module.exports = {"container":"Author_container__hG9To","details":"Author_details___Gzu_","title":"Author_title__FDLR9","description":"Author_description__QRCEK","picture":"Author_picture__L3WB3"};